@if (routeResult) {
    <div class="container-flex">
        <div class="d-flex flex-row justify-content-between">
            @if (isRideSharing) {
                <div class="d-flex flex-row justify-content-start align-items-center">
                    <h4 class="my-auto"> {{ "BEST_SOLUTION" | translate }} </h4>
                    <h4 class="rideEnabled"> {{ "WITH_RIDE_SHARING" | translate }} </h4>
                    <div class="d-inline-flex">
                        <app-tooltip
                            appCustomPopover
                            popoverText="{{ isRideSharingInRoute ? 'RIDE_SHARING_SOLUTION_ICON_ENABLED' : 'RIDE_SHARING_SOLUTION_ICON_DISABLED' }}"
                            placement="top"
                            class="ml-2 my-auto h-100"
                        >
                            <ng-container icon>
                                @if (isRideSharingInRoute) {
                                    <img class="mx-auto my-0 solution-ride-sharing-icon" id="icon-enabled"
                                         src="assets/images/icons/24_car_ride_sharing_white.svg"
                                         alt="{{'RIDE_SHARING_SOLUTION_ICON_ENABLED' | translate}}">
                                }
                                @if (!isRideSharingInRoute) {
                                    <img class="mx-auto my-0 solution-ride-sharing-icon" id="icon-disabled"
                                         src="assets/images/icons/24_car_ride_sharing_grey.svg"
                                         alt="{{'RIDE_SHARING_SOLUTION_ICON_DISABLED' | translate}}">
                                }
                            </ng-container>
                        </app-tooltip>
                    </div>
                </div>
            }
            @if (!isRideSharing) {
                <div class="d-flex flex-row justify-content-start align-items-center">
                    <h4 class="my-auto"> {{ "ALTERNATIVE_SOLUTION" | translate }} </h4>
                    <h4 class="rideDisabled"> {{ "WITHOUT_RIDE_SHARING" | translate }} </h4>
                </div>
            }
            <div class="justify-content-end d-flex">
                <button type="button" class="btn btn-primary right my-auto" (click)="select()">
                    {{ 'CHOOSE_ROUTE_BTN' | translate }}
                </button>
            </div>
        </div>
        <div class="my-3">
            <div class="d-flex justify-content-start mx-3">
                <app-route-key-number
                    translation='LATE_ARRIVALS'
                    tooltip='LATE_ARRIVALS_OBJECTIVE_INFO'
                    compareValue=''
                >
                    <ng-container content>
                        <span>{{ routeKeyNumberWeights.accurateArrivals[0] }}</span>{{ 'HOURS_SHORT' | translate }}
                        <span>{{ routeKeyNumberWeights.accurateArrivals[1] }}</span>{{ 'MINUTES_SHORT' | translate }}
                    </ng-container>
                </app-route-key-number>
                <app-route-key-number
                    translation='TRAVEL_TIME'
                    [tooltip]="transportTooltip"
                    compareValue=''
                >
                    <ng-container content>
                        <span>{{ routeKeyNumberWeights.travelTime[0] }}</span>{{ 'HOURS_SHORT' | translate }}
                        <span>{{ routeKeyNumberWeights.travelTime[1] }}</span>{{ 'MINUTES_SHORT' | translate }}
                    </ng-container>
                </app-route-key-number>
                <app-tooltip
                >
                    <ng-container icon>
                        <app-route-key-number
                            translation="UNALLOCATED"
                            tooltip="UNALLOCATED_TOOLTIP_INFO"
                            compareValue=''
                        >
                            <ng-container content>
                                <span>{{ routeKeyNumberWeights.unallocatedTasks + routeKeyNumberWeights.unallocatedTasksPatients }}</span> {{ 'TASKS' | translate }}
                            </ng-container>
                        </app-route-key-number>
                    </ng-container>
                </app-tooltip>
            </div>
        </div>
        <div class="my-3 d-flex">
            <button
                class="employee-button"
                type="button"
                (click)="prevEmployee()"
                [disabled]="currentEmployeeIndex === 0">
                <span aria-hidden="true">&lt;</span>
            </button>
            <span class="employee-name"> {{ employees[currentEmployeeIndex].employeeName }}</span>
            <button
                class="employee-button"
                type="button"
                (click)="nextEmployee()"
                [disabled]="currentEmployeeIndex === employees.length - 1">
                <span aria-hidden="true">&gt;</span>
            </button>
        </div>
        <h4 class="mt-1"> {{ "ALLOCATED_VISITS" | translate }} </h4>
        <app-table [keyboardNavigation]="true">
            <ng-container header>
                <th class="index-column" [ngClass]="{'ride-sharing-column': isRideSharing}"></th>
                <th class="flex-2 header" appTitleProvider>
                    <span>{{ 'NAME' | translate }}</span>
                </th>
                <th class="flex-3 header" appTitleProvider>
                    <span>{{ 'TASK' | translate }}</span>
                </th>
                <th class="flex-2 header" appTitleProvider>
                    <span>{{ 'ESTIMATED_VISIT' | translate }}</span>
                </th>
                <th class="flex-2 header" appTitleProvider>
                    <span>{{ 'TIME_WINDOW' | translate }}</span>
                </th>
                <th class="flex-1 header" appTitleProvider>
                    <span>{{ 'DURATION' | translate }}</span>
                </th>
            </ng-container>
            <ng-container body>
                <div class="route-comparison-solution-container">
                    @for (task of routeTasks; track task; let i = $index) {
                        <div
                            class="task-container"
                            [ngClass]="{'table-row-ride-sharing': isRideSharing}"
                        >
                            <div
                                class="travel-time-container"
                            >
                                <div class="travel-time-content">
                                    <app-tooltip
                                        appCustomPopover
                                        popoverText="{{ 'TRAVEL_TIME_TASK_TOOLTIP' | translate: {from: (getTaskFromAddress(i) | translate), to: (getTaskToAddress(i) | translate)} }}"
                                        placement="top"
                                        class="justify-content-center"
                                    >
                                        <ng-container icon>
                                            @if (showRideSharingTask(i)) {
                                                @if (task.showIcon && task.rideSharingIcon) {
                                                    <img
                                                        icon
                                                        class="mr-1"
                                                        src="/assets/images/icons/24_car_ride_sharing.svg"
                                                        alt="{{'RIDE_SHARING' | translate}}"
                                                    >
                                                }
                                            }
                                            @if (task.showIcon && !task.rideSharingIcon) {
                                                @switch (employees[currentEmployeeIndex].transport) {
                                                    @case (transportTypes.Drive) {
                                                        <img
                                                            icon
                                                            class="mr-1"
                                                            src="/assets/images/icons/24_car.svg"
                                                            alt="{{'DRIVE' | translate}}"
                                                        >
                                                    }
                                                    @case (transportTypes.Walk) {
                                                        <img
                                                            icon
                                                            class="mr-1"
                                                            src="/assets/images/icons/24_walking.svg"
                                                            alt="{{'WALK' | translate}}"
                                                        >
                                                    }
                                                    @case (transportTypes.Bicycle) {
                                                        <img
                                                            icon
                                                            class="mr-1"
                                                            src="/assets/images/icons/24_bicycle.svg"
                                                            alt="{{'BICYCLE' | translate}}"
                                                        >
                                                    }
                                                }
                                            }
                                            <span class="m-auto black">
                                                    {{ task.travelTimeFromPrev + "'" }}
                                                </span>
                                        </ng-container>
                                    </app-tooltip>
                                </div>
                                <div
                                    [ngClass]="{'travel-time-container-connection-line': !(i === routeTasks.length - 1)}"
                                ></div>
                            </div>
                            <tr [ngClass]="{'table-ride-sharing': task.rideSharingConfig}"
                                class="w-100">
                                <td class="index-column" appTitleProvider>
                                    <span> {{ i + 1 }} </span>
                                </td>
                                <td class="flex-2" appTitleProvider>
                                    <span> {{ task.name }} </span>
                                </td>
                                <td class="flex-3" appTitleProvider>
                                    @if (!task.rideSharingConfig) {
                                        <span>{{ task.serviceName }}</span>
                                    }
                                    @if (task.rideSharingConfig) {
                                        <span>{{ task.serviceName | translate: {employeeName: getRideSharingCompanionsName(task)} }}</span>
                                    }
                                </td>
                                <td class="flex-2" appTitleProvider>
                                    <span>{{ task | fromto }}</span>
                                </td>
                                <td class="flex-2" appTitleProvider>
                                    <span>{{ task.timeWindowStartTime }} - {{ task.timeWindowEndTime }}</span>
                                </td>
                                <td class="flex-1" appTitleProvider>{{ task.duration }} min</td>
                            </tr>
                        </div>
                    }
                </div>
            </ng-container>
        </app-table>
    </div>
}
